// Agent category visual system — shared crab-robot DNA, per-category color.
export const CATEGORIES = {
  Research: { hex: "#2563EB", label: "Research", ring: "ring-blue-500/50", glow: "rgba(37,99,235,0.35)", badge: "bg-blue-500/10 text-blue-300 border-blue-500/30", dot: "bg-blue-400" },
  Trading: { hex: "#10B981", label: "Trading", ring: "ring-emerald-500/50", glow: "rgba(16,185,129,0.35)", badge: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30", dot: "bg-emerald-400" },
  Security: { hex: "#EF4444", label: "Security", ring: "ring-red-500/50", glow: "rgba(239,68,68,0.35)", badge: "bg-red-500/10 text-red-300 border-red-500/30", dot: "bg-red-400" },
  Creative: { hex: "#A855F7", label: "Creative", ring: "ring-purple-500/50", glow: "rgba(168,85,247,0.35)", badge: "bg-purple-500/10 text-purple-300 border-purple-500/30", dot: "bg-purple-400" },
  Development: { hex: "#F97316", label: "Development", ring: "ring-orange-500/50", glow: "rgba(249,115,22,0.35)", badge: "bg-orange-500/10 text-orange-300 border-orange-500/30", dot: "bg-orange-400" },
  Data: { hex: "#06B6D4", label: "Data", ring: "ring-cyan-500/50", glow: "rgba(6,182,212,0.35)", badge: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30", dot: "bg-cyan-400" },
  Marketing: { hex: "#EC4899", label: "Marketing", ring: "ring-pink-500/50", glow: "rgba(236,72,153,0.35)", badge: "bg-pink-500/10 text-pink-300 border-pink-500/30", dot: "bg-pink-400" },
  Automation: { hex: "#EAB308", label: "Automation", ring: "ring-yellow-500/50", glow: "rgba(234,179,8,0.35)", badge: "bg-yellow-500/10 text-yellow-300 border-yellow-500/30", dot: "bg-yellow-400" },
};

export const CATEGORY_LIST = Object.keys(CATEGORIES);

export function getCategory(name) {
  return CATEGORIES[name] || CATEGORIES.Research;
}

export const STATUS_STYLES = {
  ONLINE: { label: "Online", dot: "bg-emerald-400", text: "text-emerald-300" },
  WORKING: { label: "Working", dot: "bg-cyan-400", text: "text-cyan-300" },
  COLLABORATING: { label: "Collaborating", dot: "bg-violet-400", text: "text-violet-300" },
  VERIFYING: { label: "Verifying", dot: "bg-amber-400", text: "text-amber-300" },
  OFFLINE: { label: "Offline", dot: "bg-slate-500", text: "text-slate-400" },
};

export function getStatus(status) {
  return STATUS_STYLES[status] || STATUS_STYLES.ONLINE;
}
